import {media} from '../styles/media.styled';

export const getSectionProps = (section = {}) => {
  return {
    maxWidth: section.maxWidth,
    textColor: section.textColor,
    align: section.align,
    background: section.background,
    paddingLg: section.paddingLg,
    marginLg: section.marginLg,
    padding: section.padding,
    margin: section.margin
  };
};


export const isViewport = (viewport, expected) =>
  viewport === 'all' ||
  (Array.isArray(expected) ? expected.indexOf(viewport) !== -1 : viewport === expected);

export const isDefined = (value) => value !== null && value !== undefined;


const mapping = (value, map) => typeof map === 'function' ? map(value) : map ? map[value] : value;

export const cssStyle = (style, value, map, postFix = '', content) => {
  if (isDefined(value))
    return content || `${style}:${mapping(value, map)}${postFix};`;
  return '';
};
export const cssStyleXs = (viewport, style, value, map, postFix = '', content) => {
  if (isDefined(value))
    if (isViewport(viewport, ['md','lg', 'xl']))
      return media.xs(cssStyle(style, value, map, postFix, content));
    else
      return cssStyle(style, value, map, postFix, content);

  return '';
};
export const cssStyleMd = (viewport, style, value, map, postFix = '', content) => {
  if (isDefined(value))
    if (isViewport(viewport, ['lg', 'xl']))
      return media.md(cssStyle(style, value, map, postFix, content));
    else
      return cssStyle(style, value, map, postFix, content);

  return '';
};
export const cssStyleLg = (viewport, style, value, map, postFix = '', content) => {
  if (isDefined(value))
    if (isViewport(viewport, 'xl'))
      return media.lg(cssStyle(style, value, map, postFix, content));
    else
      return cssStyle(style, value, map, postFix, content);

  return '';
};

export const cssStyleXl = (viewport, style, value, map, postFix = '', content) => {
  if (isDefined(value))
    return cssStyle(style, value, map, postFix, content);
  return '';
};

export const cssStyleResponsive = (viewport, style, value, map, postFix = '') => {
  if (isDefined(value)) {
    return `
      ${cssStyle(style, typeof value === 'object' ? value.xl : value, map, postFix)}
      ${cssStyleLg(viewport, style, value.lg, map, postFix)}
      ${cssStyleMd(viewport, style, value.md, map, postFix)}
      ${cssStyleXs(viewport, style, value.xs, map, postFix)}
    `;
  }
  return '';
};
export const cssBlock = (value, content) => {
  if (value) {
    return `
      ${cssStyle(null, value ? true : null, null, null, content)}
    `;
  }
  return '';
};

export const cssBlockResponsive = (viewport, value, content) => {
  if (value) {
    return `
      ${cssStyle(null, value.xl ? true : null, null, null, content)}
      ${cssStyleLg(viewport, null, value.lg ? true : null, null, null, content)}
      ${cssStyleMd(viewport, null, value.md ? true : null, null, null, content)}
      ${cssStyleXs(viewport, null, value.xs ? true : null, null, null, content)}
    `;
  }
  return '';
};
